import { create } from 'zustand';

/**
 * The in-app banners (FR-029/FR-030, data-model.md B1): one incoming-message
 * banner and one community-update banner at a time, newest wins — as on
 * Android (mobile/src/state/messagingStore.ts). Dismissing a banner does not
 * mark anything read: the conversation stays unread in Messages.
 */
export interface MessageBanner {
  conversationId: string;
  senderId: string;
  senderName: string;
  preview: string;
}

export interface CommunityBanner {
  title?: string;
  text: string;
  targetType?: 'post' | 'event' | 'promotion' | 'announcement';
  targetId?: string;
}

/** New offers on the member's posts; `postId` is the post when they are all on one, else null (leads to My posts). */
export interface OffersBanner {
  count: number;
  postId: string | null;
}

interface BannerState {
  message: MessageBanner | null;
  community: CommunityBanner | null;
  offers: OffersBanner | null;
  showMessage: (banner: MessageBanner) => void;
  dismissMessage: () => void;
  showCommunity: (banner: CommunityBanner) => void;
  dismissCommunity: () => void;
  showOffers: (banner: OffersBanner) => void;
  dismissOffers: () => void;
  clear: () => void;
}

export const useBannerStore = create<BannerState>()((set) => ({
  message: null,
  community: null,
  offers: null,
  showMessage: (message) => set({ message }),
  dismissMessage: () => set({ message: null }),
  showCommunity: (community) => set({ community }),
  dismissCommunity: () => set({ community: null }),
  showOffers: (offers) => set({ offers }),
  dismissOffers: () => set({ offers: null }),
  clear: () => set({ message: null, community: null, offers: null }),
}));
